module.exports = __webpack_public_path__ + "img/help.c87a47c7.svg";